import React from 'react';

const BackgroundImage = () => {
  return (
    <div className="background-image">
      {/* Add any content you want to overlay on the background image here */}
    </div>
  );
};

export default BackgroundImage;